import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Box, makeStyles, Typography, Grid } from "@material-ui/core";

import { CLICKING } from "..";
import { COLORS } from "../../../../../theme/colors";
import { TextInput } from "../../../../../components/base";
import endPoints from "../../../../../services/apiEndPoints";
import { getData, putData } from "../../../../../services";

const infoFields = [
  {
    key: "total_square",
    title: "Total building area",
    suffix: "sqft",
  },
  {
    key: "roof_square",
    title: "Roof area",
    suffix: "sqft",
  },
  {
    key: "current_economic_vacancy_rate",
    title: "Current economic vacancy rate",
    suffix: "%",
  },
  {
    key: "current_physical_vacancy_rate",
    title: "Current physical vacancy rate",
    suffix: "%",
  },
  {
    key: "total_unit",
    title: "Number of units",
    suffix: null,
  },
  {
    key: "total_tenants",
    title: "Number of tenants",
    suffix: null,
  },
];

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: 30,
    fontWeight: 700,
    marginBottom: 50,
  },
  root: {
    flexGrow: 1,
    paddingBottom: 100,
  },
  paper: {
    padding: theme.spacing(0.5),
    fontSize: 16,
    fontWeight: 400,
    color: COLORS.blackShade,
  },
  box: {
    display: "flex",
  },
  Input: {
    width: 600,
  },
  rightDiv: {
    "& .MuiGrid-justify-content-xs-center": {
      justifyContent: "flex-start",
    },
  },
}));

const BuildingInfo = ({ building, handleNext, clicking, setClicking, setLoading, onError }) => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);

  const apiUrl = endPoints.OB_OPERATOR_BUILDING_INFO.replace("{id}", building.id);
  const [data, setData] = useState({});

  useEffect(() => {
    infoFields.forEach((item) => {
      if (item.suffix === "sqft") item.suffix = user?.unit_system;
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    getData(apiUrl, setData)
      .catch(onError)
      .finally(() => setLoading(false));
  }, [building]);

  useEffect(() => {
    if (clicking === CLICKING.none) return;
    setLoading(true);
    putData(
      apiUrl,
      () => {
        if (clicking === CLICKING.next) {
          setClicking(CLICKING.none);
        }
        handleNext();
      },
      data
    )
      .catch(onError)
      .finally(() => {
        setLoading(false);
        setClicking(CLICKING.none);
      });
  }, [clicking]);

  return (
    <Box>
      <Typography className={classes.heading}>
        First, Let&apos;s verify the details we already have
      </Typography>
      <div className={classes.root}>
        {infoFields.map((field, i) => {
          return (
            <Grid container spacing={3} key={i}>
              <Grid item xs>
                <Box className={classes.paper}>{field.title}:</Box>
              </Grid>
              <Grid item xs={8} className={classes.rightDiv}>
                <Box className={classes.Input}>
                  <TextInput
                    style={{ background: COLORS.white, width: "180px" }}
                    value={data[field.key]}
                    type="number"
                    containerStyle={classes.box}
                    suffix={field.suffix ? field.suffix : ""}
                    onChange={(v) => setData({ ...data, [field.key]: v !== "" ? v : null })}
                  />
                </Box>
              </Grid>
            </Grid>
          );
        })}
      </div>
    </Box>
  );
};

export default BuildingInfo;
